<template>
  <div>
    <div v-editable="blok.header1[0]">
      <StoryblokComponent v-if="blok" :key="blok.header1[0]._uid" :blok="blok.header1[0]" no-border-radius />
    </div>
    <div>
      <div
        class="container container--inline container--small h-hide-tablet-up">
        <LazyCircleList
          v-if="mainNavigation"
          class="h-margin-top"
          :items="mainNavigation.filter(item => item.valid)">
          <template #header>
            <h3 class="h2 h-padding-mobile h-text-center">
              {{ $t('general/go-shopping') }}
            </h3>
          </template>
        </LazyCircleList>
      </div>
      <div
        class="container container--inline container--no-padding-mobile container--small">
        <Grid>
          <Cell
            v-editable="blok.promo_left[0]"
            size="12"
            tablet="6">
            <StoryblokComponent :key="blok.promo_left[0]._uid" :blok="blok.promo_left[0]" />
          </Cell>
          <Cell
            v-editable="blok.promo_right[0]"
            size="12"
            tablet="6">
            <StoryblokComponent :key="blok.promo_right[0]._uid" :blok="blok.promo_right[0]" />
          </Cell>
        </Grid>
      </div>

      <div
        v-if="blok.header2[0]"
        v-editable="blok.header2[0]"
        class="container container--inline container--no-padding h-align-center">
        <StoryblokComponent :key="blok.header2[0]._uid" :blok="blok.header2[0]" no-border-radius />
      </div>
    </div>
  </div>
</template>
<script setup>
const config = useRuntimeConfig()
const { timedNavigation } = useTimedNavigation()
const { $lang } = useNuxtApp()

defineProps({ blok: Object })

const mainNavigation = computed(() => {
  return timedNavigation({ filterByLocation: 'main' })
    .map(item => {
      if (typeof item.images !== 'undefined' && item.images) {
        const image = item.images.find(image => {
          return image.type === 'product'
        })
        item.image = `${config.public.cdnURL}pictures/thumbs/${image.value}-thumbnail.webp`
      }
      return {
        ...item,
        slug: `/${$lang}/${item.slug}`
      }
    })
})
</script>
